export default __webpack_public_path__ + "static/media/five.97c05dfa.jpg";